var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlatformAndroidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_2112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.2504 7.12381C8.88725 7.12381 10.2142 5.89896 10.2142 4.38802C10.2142 2.87708 8.88725 1.65222 7.2504 1.65222C5.61355 1.65222 4.28662 2.87708 4.28662 4.38802C4.28662 5.89896 5.61355 7.12381 7.2504 7.12381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49766 3.70447H5.00314C4.60742 3.70447 4.28662 4.02526 4.28662 4.42099V8.91551C4.28662 9.31123 4.60742 9.63203 5.00314 9.63203H9.49766C9.89338 9.63203 10.2142 9.31123 10.2142 8.91551V4.42099C10.2142 4.02526 9.89338 3.70447 9.49766 3.70447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.22695 1.21391C5.17027 1.11165 5.20721 0.982803 5.30947 0.92612C5.41173 0.869437 5.54058 0.906383 5.59726 1.00864L6.74991 3.08808C6.8066 3.19034 6.76965 3.31919 6.66739 3.37587C6.56513 3.43255 6.43629 3.39561 6.3796 3.29335L5.22695 1.21391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3444 5.16886C10.3444 4.73717 10.6944 4.38721 11.1261 4.38721C11.5578 4.38721 11.9077 4.73717 11.9077 5.16886V7.93723C11.9077 8.36892 11.5578 8.71888 11.1261 8.71888C10.6944 8.71888 10.3444 8.36892 10.3444 7.93723V5.16886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.57634 8.32878C7.57634 7.89708 7.9263 7.54712 8.35799 7.54712C8.78969 7.54712 9.13965 7.89708 9.13965 8.32878V11.0971C9.13965 11.5288 8.78969 11.8788 8.35799 11.8788C7.9263 11.8788 7.57634 11.5288 7.57634 11.0971V8.32878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.27256 1.21391C9.32924 1.11165 9.2923 0.982803 9.19004 0.92612C9.08778 0.869437 8.95893 0.906383 8.90225 1.00864L7.7496 3.08808C7.69291 3.19034 7.72986 3.31919 7.83212 3.37587C7.93438 3.43255 8.06323 3.39561 8.11991 3.29335L9.27256 1.21391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1556 5.16886C4.1556 4.73717 3.80564 4.38721 3.37394 4.38721C2.94224 4.38721 2.59229 4.73717 2.59229 5.16886V7.93723C2.59229 8.36892 2.94224 8.71888 3.37394 8.71888C3.80564 8.71888 4.1556 8.36892 4.1556 7.93723V5.16886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92366 8.32878C6.92366 7.89708 6.5737 7.54712 6.14201 7.54712C5.71031 7.54712 5.36035 7.89708 5.36035 8.32878V11.0971C5.36035 11.5288 5.71031 11.8788 6.14201 11.8788C6.5737 11.8788 6.92366 11.5288 6.92366 11.0971V8.32878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2504 7.12381C8.88725 7.12381 10.2142 5.89896 10.2142 4.38802C10.2142 2.87708 8.88725 1.65222 7.2504 1.65222C5.61355 1.65222 4.28662 2.87708 4.28662 4.38802C4.28662 5.89896 5.61355 7.12381 7.2504 7.12381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49766 3.70447H5.00314C4.60742 3.70447 4.28662 4.02526 4.28662 4.42099V8.91551C4.28662 9.31123 4.60742 9.63203 5.00314 9.63203H9.49766C9.89338 9.63203 10.2142 9.31123 10.2142 8.91551V4.42099C10.2142 4.02526 9.89338 3.70447 9.49766 3.70447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.88018 3.18127C5.95181 3.18127 6.00988 3.1232 6.00988 3.05157C6.00988 2.97994 5.95181 2.92188 5.88018 2.92188C5.80856 2.92188 5.75049 2.97994 5.75049 3.05157C5.75049 3.1232 5.80856 3.18127 5.88018 3.18127Z",
    fill: "#16A665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61651 3.18127C8.68814 3.18127 8.74621 3.1232 8.74621 3.05157C8.74621 2.97994 8.68814 2.92188 8.61651 2.92188C8.54488 2.92188 8.48682 2.97994 8.48682 3.05157C8.48682 3.1232 8.54488 3.18127 8.61651 3.18127Z",
    fill: "#16A665"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_2112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.8913,
    height: 11.113,
    fill: "white",
    transform: "translate(0.265137 0.823486)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformAndroidIcon);
export default __webpack_public_path__ + "static/media/platformAndroidIcon.532502bf87250d67c78d122452b18114.svg";
export { ForwardRef as ReactComponent };